<script>
  // A job waiting its turn behind whatever is running.
  import { createEventDispatcher } from "svelte";
  import JobCard from "../UI/JobCard.svelte";
  import IconButton from "../UI/IconButton.svelte";
  import { download, dequeueJob } from "../../lib/jobs.js";
  import { formatDateTime } from "../../lib/format.js";

  export let fileId;
  export let filename;
  export let uploadedDateTime;

  const dispatch = createEventDispatcher();

  async function dequeue() {
    if (await dequeueJob(fileId)) dispatch("changed");
  }

  $: meta = [{ label: "Uploaded", value: formatDateTime(uploadedDateTime) }];
</script>

<JobCard id={fileId} title={filename} status="queued" {meta}>
  <svelte:fragment slot="actions">
    <IconButton
      tip="Download input python file"
      icon="fa-code"
      colour="warning"
      onClick={() => download.python(fileId)}
    />
    <IconButton
      tip="Download input excel file"
      icon="fa-file-excel"
      colour="success"
      onClick={() => download.inputExcel(fileId)}
    />
    <IconButton
      tip="Remove from queue"
      icon="fa-minus"
      colour="error"
      onClick={dequeue}
    />
  </svelte:fragment>
</JobCard>
